import { Component, OnChanges, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { GenService } from 'app/shared/gen-ser.service';
import { DataService } from 'app/shared/dataservice.service';
import { FinishedGoodsToken, FinishedGoodsDaily } from 'app/shared/misc-classes';
import { ModalDirective } from 'ngx-bootstrap';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'finished-goods-day-view',
  templateUrl: './finished-goods-day-view.component.html',
  styleUrls: ['./finished-goods-day-view.component.css']
})
export class FinishedGoodsDayViewComponent implements OnChanges,OnInit {

  editHeader: string = "";
  modalErrorMessage: string = "";
  editFgCurrentDayObj: FinishedGoodsDaily;

  @Input() currMonthDtObj: Date;
  @Input() mId: string;
  @Input() fgCurrentDayObj: FinishedGoodsDaily;

  @Output() dateChanged: EventEmitter<any> = new EventEmitter();
  @Output() reloadData: EventEmitter<any> = new EventEmitter();
  @ViewChild('childModal') public childModal: ModalDirective;

  CBList:Array<dropFilterItem> = [];
  selectedCBs:Array<string> = [];

  SOIncoTermList:Array<dropFilterItem> = [];
  selectedSOIncoTerms:Array<string> = [];

  CustomerList:Array<dropFilterItem> = [];
  selectedCustomers:Array<string> = [];

  OHEList:Array<dropFilterItem> = [];
  selectedOHEs:Array<string> = [];

  totalRecordsCount:number = 0;
  filteredRecordsCount:number = 0;
  totalQuantity:number = 0;
  constructor(private _dataService: DataService, private _notify: NotificationsService) { }

  ngOnInit(){
    this.reloadFilters();
  }
  ngOnChanges() {

    this.reloadFilters();

  }

  filterFGTokens():Array<FinishedGoodsToken>{
    let _tmpTotalQuantity:number = 0;
    let _filteredFGTokens:Array<FinishedGoodsToken> = this.fgCurrentDayObj.FGTokens.filter((_tmpFGToken:FinishedGoodsToken) => {
        if(this.selectedCBs && this.selectedCBs.length > 0){
          if(this.selectedCBs.indexOf(_tmpFGToken.cb) < 0){
            return false;
          } 
        }

        if(this.selectedSOIncoTerms && this.selectedSOIncoTerms.length > 0){
          if(this.selectedSOIncoTerms.indexOf(_tmpFGToken.salesorder_incoterm) < 0){
            return false;
          } 
        }

        if(this.selectedCustomers && this.selectedCustomers.length > 0){
          if(this.selectedCustomers.indexOf(_tmpFGToken.customer) < 0){
            return false;
          } 
        }

        if(this.selectedOHEs && this.selectedOHEs.length > 0){
          if(this.selectedOHEs.indexOf(_tmpFGToken.ohe) < 0){
            return false;
          }
        }

        _tmpTotalQuantity += Number(_tmpFGToken.qty);
      
        return true;
    });
    this.totalQuantity = _tmpTotalQuantity;
    this.filteredRecordsCount = _filteredFGTokens.length;
    return _filteredFGTokens;
  }

  reloadFilters(){
    this.totalRecordsCount = this.fgCurrentDayObj.FGTokens.length;
    this.filteredRecordsCount = 0;
    
    let _tmpCBList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _cb:string = _tmpFGToken.cb;
      let _tmpDropItem:dropFilterItem = _tmpCBList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _cb;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tmpCBList.push(new dropFilterItem(_cb,_cb))    
      }

    });
    _tmpCBList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.CBList = _tmpCBList;


    let _tmpSOIncoTermList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _soincoterm:string = _tmpFGToken.salesorder_incoterm;
      let _tmpDropItem:dropFilterItem = _tmpSOIncoTermList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _soincoterm;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tmpSOIncoTermList.push(new dropFilterItem(_soincoterm,_soincoterm))    
      }

    });
    _tmpSOIncoTermList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.SOIncoTermList = _tmpSOIncoTermList;

    let _tmpCustomerList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _customer:string = _tmpFGToken.customer;
      let _tmpDropItem:dropFilterItem = _tmpCustomerList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _customer;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tmpCustomerList.push(new dropFilterItem(_customer,_customer))    
      }

    });
    _tmpCustomerList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.CustomerList = _tmpCustomerList;


    let _tmpOHEList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _ohe:string = _tmpFGToken.ohe;
      let _tmpDropItem:dropFilterItem = _tmpOHEList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _ohe;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tmpOHEList.push(new dropFilterItem(_ohe,_ohe))    
      }

    });
    _tmpOHEList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.OHEList = _tmpOHEList;
  }
  formatDate(excelDate){
    var m_names = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
    var _dt = new Date((excelDate - (25567 + 2))*86400*1000)
    return _dt.getDate()+"-"+m_names[_dt.getMonth()];

  }
  formatHeaderDate(_date: Date): string {
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  prevDateSel(): void {
    let _newDate: Date = new Date(this.currMonthDtObj.getTime());
    _newDate.setDate(_newDate.getDate() - 1);
    this.dateChanged.emit({ "date": _newDate });
  }
  nextDateSel(): void {
    let _newDate: Date = new Date(this.currMonthDtObj.getTime());
    _newDate.setDate(_newDate.getDate() + 1);
    this.dateChanged.emit({ "date": _newDate });
  }

  hasEditAccess(_pid: string) {
    return this._dataService.hasEditAccess(this.mId, _pid);
  }
  editStatus() {
    this.editFgCurrentDayObj = this.fgCurrentDayObj.cloneSelf();
    this.showChildModal();
  }

  hasReadAccess(_pid: string) {
    return this._dataService.hasReadAccess(this.mId, _pid);
  }
  showChildModal() {
    this.editHeader = "Edit Finished Goods Status";
    this.childModal.show();
  }
  hideChildModal() {
    this.childModal.hide();
  }
  saveChanges() {
    if (this.validateData() == true) {
      this._dataService.saveFgMonthlyData(this.editFgCurrentDayObj).subscribe((res: boolean) => {
        if (res == true) {
          this._notify.success('Success', 'Data Saved.', this._dataService.successOptions);
          this.hideChildModal();
          this.reloadData.emit();
        }
        else {
          this._notify.error('Failure', 'Failed to Save.', this._dataService.failureOptions);
        }
      });
    }
  }

  validateData(): boolean {
    if (this.editFgCurrentDayObj.domesticBreaker == "" || !GenService.IsValidNumber(this.editFgCurrentDayObj.domesticBreaker) == true) {
      this.modalErrorMessage = 'Domestic Breaker value should be a Number.';
      return false;
    }
    if (this.editFgCurrentDayObj.exportBreaker == "" || !GenService.IsValidNumber(this.editFgCurrentDayObj.exportBreaker)== true) {
      this.modalErrorMessage = 'Export Breaker value should be a Number.';
      return false;
    }
    if (this.editFgCurrentDayObj.magneticActuator =="" || !GenService.IsValidNumber(this.editFgCurrentDayObj.magneticActuator) == true) {
      this.modalErrorMessage = 'Magnetic Actuator value should be a Number.';
      return false;
    }

    return true;
  }
}


class dropFilterItem{
  private _counter:number;
  constructor(private _itemLabel:string,public ItemId:string){
    this._counter = 1;
  }

  itemFoundAgain(){
    this._counter++;
  }

  get ItemLabel():string{
    return this._itemLabel +" ("+ this._counter +
          (this._counter == 1 ? " order)":" orders)");;
  }
}